export var iconSizeMap = {
  s: 's',
  m: 'm',
  l: 'm'
};
export var avatarSizeMap = {
  s: 32,
  m: 44,
  l: 56
};
export var textSizeMap = {
  s: 'body-accent-small',
  m: 'body-accent-small',
  l: 'body-accent-medium'
};
export var getInitialsForName = function getInitialsForName(name) {
  var _words$0$, _words$, _words$1$, _words$2;
  if (!name) {
    return '';
  }
  if (name.charAt(0) === '+') {
    return name;
  }
  var words = name.split(' ');
  return "".concat(((_words$0$ = (_words$ = words[0]) === null || _words$ === void 0 ? void 0 : _words$[0]) !== null && _words$0$ !== void 0 ? _words$0$ : '').toUpperCase()).concat(((_words$1$ = (_words$2 = words[1]) === null || _words$2 === void 0 ? void 0 : _words$2[0]) !== null && _words$1$ !== void 0 ? _words$1$ : '').toUpperCase());
};
export var getAvatarMode = function getAvatarMode(_ref) {
  var image = _ref.image,
    icon = _ref.icon,
    logo = _ref.logo;
  if (image) {
    return 'image';
  }
  if (icon) {
    return 'icon';
  }
  if (logo) {
    return 'logo';
  }
  return 'name';
};